import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [];

const buttonVariations = [
  {
    label: <>Earn Up to 9.5% on XRP</>,
    title: <>Nexo: Maximize Your XRP Yield</>,
    content: <>Create a Nexo account, buy or transfer XRP, and earn up to 9.5% interest.</>,
    href: "https://api.xrpscan.com/api/v1/campaign/nexoearn1",
  },
  {
    label: <>Borrow against XRP from 1.9%</>,
    title: <>Nexo: Use Your XRP as Collateral</>,
    content: <>Create a Nexo account, buy or transfer XRP, and borrow stablecoins from 1.9% interest.</>,
    href: "https://api.xrpscan.com/api/v1/campaign/nexoborrow1",
  },
]

let variantIndex = 0;
try {
  variantIndex = Math.floor(Math.random() * buttonVariations.length);
} catch (error) {}
const buttonVariation = buttonVariations[variantIndex];

const NexoButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        {buttonVariation.title}
        <span className="small ml-1"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>{buttonVariation.content}</Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href={buttonVariation.href}
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >{buttonVariation.label}</Button>
        </OverlayTrigger>
    </span>
  )
}

NexoButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default NexoButton;